import {
	GetMyOperatorInfoResponse,
	GetMyOperatorSpinOrderByUsernameRequest,
	GetMyOperatorSpinOrderByUsernameResponse,
	GetMyOperatorSpinBetDetailRequest,
	GetMyOperatorSpinBetDetailResponse,
	GetMyOperatorSpinOrderSummaryByUsernamesRequest,
	GetMyOperatorSpinOrderSummaryByUsernamesResponse,
	GetOperatorSupportResponse,
	GetOperatorWinningQuotaRequest,
	GetOperatorWinningQuotaResponse,
	UpdateMyOperatorCallbackUrlRequest,
	UpdateOperatorSupportRequest,
	GetMyOperatorBuyQuotaActivityLogRequest,
	GetMyOperatorBuyQuotaActivityLogResponse,
} from "@/types/support";
import axios from "@/utils/axios";

export const getOperatorSupportMe =
	async (): Promise<GetOperatorSupportResponse> => {
		const { data } = await axios.get("/operator-supports/me");
		return data;
	};

export const updateOperatorSupport = async (
	payload: UpdateOperatorSupportRequest,
): Promise<GetOperatorSupportResponse> => {
	const { data } = await axios.put("/operator-supports/update-my", payload);
	return data;
};

export const getMyOperatorSpinOrderSummaryByUsernames = async (
	payload: GetMyOperatorSpinOrderSummaryByUsernamesRequest,
): Promise<GetMyOperatorSpinOrderSummaryByUsernamesResponse> => {
	const { data } = await axios.post(
		"/operator-supports/get-my-operator-spin-order-summary-by-usernames",
		payload,
	);
	return data;
};

export const getMyOperatorSpinOrderByUsername = async (
	payload: GetMyOperatorSpinOrderByUsernameRequest,
): Promise<GetMyOperatorSpinOrderByUsernameResponse> => {
	const { data } = await axios.post(
		"/operator-supports/get-my-operator-spin-order-by-username",
		payload,
	);
	return data;
};

export const getMyOperatorSpinBetDetail = async (
	payload: GetMyOperatorSpinBetDetailRequest,
): Promise<GetMyOperatorSpinBetDetailResponse> => {
	const { data } = await axios.post(
		"/operator-supports/get-my-operator-spin-bet-detail",
		payload,
	);
	return data;
};

export const getOperatorWinningQuota = async (
	payload: GetOperatorWinningQuotaRequest,
): Promise<GetOperatorWinningQuotaResponse> => {
	const { data } = await axios.post(
		"/operator-supports/get-my-operator-winning-quota",
		payload,
	);
	return data;
};

export const getMyOperatorInfo =
	async (): Promise<GetMyOperatorInfoResponse> => {
		const { data } = await axios.post(
			"/operator-supports/get-my-operator-info",
		);
		return data;
	};

export const updateMyOperatorCallbackUrl = async (
	payload: UpdateMyOperatorCallbackUrlRequest,
): Promise<GetMyOperatorInfoResponse> => {
	const { data } = await axios.post(
		"/operator-supports/update-my-operator-callback-url",
		payload,
	);
	return data;
};

export const resetMyPrivateKey =
	async (): Promise<GetMyOperatorInfoResponse> => {
		const { data } = await axios.post(
			"/operator-supports/reset-my-operator-private-key",
		);
		return data;
	};

export const getMyOperatorBuyQuotaActivityLog = async (
	payload: GetMyOperatorBuyQuotaActivityLogRequest,
): Promise<GetMyOperatorBuyQuotaActivityLogResponse> => {
	try {
		const response = await axios.post(
			`/operator-supports/get-my-operator-buy-quota-activity-log`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyOperatorBuyQuotaActivityLogSummary = async (
	payload: GetMyOperatorBuyQuotaActivityLogRequest,
): Promise<{
	totalWinningQuotaBuy: number;
	totalWinningQuotaBuyUnsuccessful: number;
}> => {
	try {
		const response = await axios.post(
			`/operator-supports/get-my-operator-buy-quota-activity-log-summary`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};
